module.exports = __webpack_public_path__ + "static/media/testimonial_kuncoro.73626792.png";